// ============================================================
// chat_badge_controller.js
// 네비게이션 채팅 메뉴 읽지 않은 메시지 뱃지 컨트롤러
//
// 동작 방식:
//   - 컨트롤러 연결 시 즉시 unread_count 엔드포인트 폴링
//   - 30초 간격으로 반복 폴링
//   - count > 0 이면 badge 타겟 표시, count = 0 이면 숨김
//   - 데스크톱/모바일 두 badge 타겟 동시 관리
//
// 사용 위치: application.html.erb <nav> 태그
// 엔드포인트: GET /talk/unread_count → { count: N }
// ============================================================

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  // badge 타겟: 데스크톱 + 모바일 양쪽에 동일한 타겟명 사용
  // url 값: 폴링할 엔드포인트 URL (Rails 라우트로 주입)
  static targets = ["badge"]
  static values  = { url: String }

  // ── connect() ─────────────────────────────────────────────
  // 컨트롤러 DOM 연결 시 즉시 1회 폴링 후 30초 인터벌 시작
  connect() {
    this._poll()
    this._timer = setInterval(() => this._poll(), 30_000)
  }

  // ── disconnect() ──────────────────────────────────────────
  // 컨트롤러 DOM 제거 시 인터벌 정리 (메모리 누수 방지)
  disconnect() {
    clearInterval(this._timer)
  }

  // ── Private: _poll() ─────────────────────────────────────
  // /talk/unread_count 를 fetch하여 뱃지 표시/숨김 업데이트
  _poll() {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(this.urlValue, {
      headers: {
        "Accept":       "application/json",
        "X-CSRF-Token": csrfToken || ""
      },
      credentials: "same-origin"
    })
    .then(res => res.json())
    .then(({ count }) => {
      // count > 0 이면 모든 badge 타겟 표시, 0 이면 숨김
      this.badgeTargets.forEach(badge => {
        if (count > 0) {
          badge.classList.remove("hidden")
        } else {
          badge.classList.add("hidden")
        }
      })
    })
    .catch(() => {
      // 네트워크 오류 시 뱃지 숨김 유지 (사일런트 실패)
    })
  }
}
